import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  InputAdornment,
  Pagination,
  TextField,
  useMediaQuery,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import CircularProgress from "@mui/material/CircularProgress";

import Filter from "../Filter/Filter";
import "./studying.scss";
import CardCourse from "../CardCourse/CardCourse";
import Empty from "../Empty/Empty";
import filterIcon from "../../../../assets/icons/filter.svg";

const Studying = ({
  studies,
  categories,
  teachers,
  setFilter,
  filter,
  studiesNumber,
  loading,
  addFavorites,
}: any) => {
  const [isMobileFilter, setIsMobileFilter] = useState(false);
  const isMobile = useMediaQuery("(max-width:1000px)");

  const sortData = [
    { name: "Наименование от А до Я", id: "NAME_ASCENDING" },
    { name: "Наименование от Я до А", id: "NAME_DESCENDING" },
  ];

  const handleChangeSearch = (e: string) => {
    setFilter({ ...filter, search: [e] });
  };

  const handleChangeOrder = (event: SelectChangeEvent) => {
    setFilter({ ...filter, order_by: [event] });
  };

  const handleChangePage = (_: any, number: number) => {
    if (Math.abs(studiesNumber - (number - 1) * 12) < 12) {
      setFilter({
        ...filter,
        page: [number - 1],
        limit: [Math.abs(studiesNumber - (number - 1) * 12)],
      });
    } else {
      setFilter({ ...filter, page: [number - 1], limit: [12] });
    }
  };

  const Content = () => {
    if (loading) {
      return (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            margin: "186px auto",
          }}>
          <CircularProgress />
        </Box>
      );
    } else {
      if (studies?.length) {
        return (
          <Box className={"studying-cards"}>
            {studies?.map((el: any) => {
              return (
                <CardCourse
                  key={el?.id}
                  info={el}
                  addFavorites={addFavorites}
                />
              );
            })}
          </Box>
        );
      } else {
        return (
          <Empty
            title={"У вас пока нет таких курсов"}
            subtitle={"Поменяйте параметра фильтра"}
            btn={false}
          />
        );
      }
    }
  };

  return (
    <Box className={"studying-wrapper"}>
      <Dialog
        open={isMobileFilter}
        onClose={() => setIsMobileFilter(false)}
        scroll="body"
        PaperProps={{
          sx: {
            width: "90%",
            borderRadius: "8px",
          },
        }}>
        <Filter
          categories={categories}
          teachers={teachers}
          filter={filter}
          setFilter={setFilter}
          setIsMobileFilter={setIsMobileFilter}
        />
      </Dialog>

      {!isMobile && (
        <Filter
          categories={categories}
          teachers={teachers}
          filter={filter}
          setFilter={setFilter}
        />
      )}
      <Box sx={{ width: "100%" }}>
        {isMobile && (
          <Button
            sx={{
              width: "145px",
              height: "32px",
              border: "1px solid rgba(1, 18, 36, 0.12)",
              marginBottom: "12px",
              borderRadius: "8px",
              textTransform: "unset",
            }}
            onClick={() => setIsMobileFilter(true)}
            color="primary">
            <img
              src={filterIcon}
              alt="filter-icon"
              style={{
                marginRight: "10px",
              }}
            />
            Фильтровать
          </Button>
        )}

        <Box className={"studying-action"}>
          <Box className={"studying-search-wrapper"}>
            <TextField
              className={"studying-search"}
              id="header-search"
              placeholder="Поиск по ключевым словам"
              value={filter.search[0]}
              size="small"
              onChange={(e) => handleChangeSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
          </Box>

          <Box
            sx={{
              "@media (max-width: 1000px)": {
                width: "97%",
              },
            }}>
            <FormControl fullWidth>
              <InputLabel sx={{ top: "-5px" }}>Сортировать по:</InputLabel>
              <Select
                className={"studying-order"}
                value={filter.order_by[0]}
                label="Сортировать по:"
                onChange={(e) => handleChangeOrder(e.target.value)}>
                {sortData.map((el) => (
                  <MenuItem value={el.id} key={el.id}>
                    {el.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </Box>
        <Content />
        {loading ? null : (
          <Box className={"pagination-wrapper"}>
            <Pagination
              count={Math.ceil(studiesNumber / 12)}
              page={+filter.page + 1}
              shape="rounded"
              onChange={handleChangePage}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Studying;
